// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"94b99ee8","280":"93dead3d","494":"7b932b05"}[chunkId] + ".chunk.js";
};